import { isAxiosError } from 'axios'

import httpClient from '../../httpClient.ts'
import { WrongCredentialsError } from './exceptions.ts'
import { LoginResponse } from './types.ts'

const token = async (email: string, password: string) => {
  try {
    const response = await httpClient.post<LoginResponse>(
      'rest_framework_simple_jwt/token/',
      {
        email,
        password
      }
    )
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response?.status == 401) {
        throw new WrongCredentialsError()
      }
    }
    throw new Error('An unexpected error occurred')
  }
}

export const restFrameworkSimpleJwt = {
  login: token
}
